import React from 'react';
import Loadable from 'react-loadable';

/**
 * 2019.02월 이후 react-loadable이 Webpack v4+과 Babel v7+에 더이상 호환이 되지 않으며,
 * 유지보수가 되지 않는 문제가 있다고함.
 * 그의 대안을 위한 @loadable/component로 대체예정
 * ex) import loadable from '@loadable/component';
 * export const SongsCopyRight = loadable(
      () => import('./playlist/SongsCopyRight'),
      {
        fallback: Loading,
        log: console.log('@loadable/component test'),
      },
   );
 */
// import loadable from '@loadable/component';

export const Loading = (x, y, z) => {
  return <div />;
};

//* Info *//
export const InfoTerm = Loadable({
  loader: () => import('./info/Term'),
  loading: Loading,
});

export const InfoTermAndPolicy = Loadable({
  loader: () => import('./info/TermAndPolicy'),
  loading: Loading,
});

export const InfoPolicy = Loadable({
  loader: () => import('./info/Policy'),
  loading: Loading,
});

export const MobileOnly = Loadable({
  loader: () => import('./MobileOnly'),
  loading: Loading,
});

export const InfoLicense = Loadable({
  loader: () => import('./info/License'),
  loading: Loading,
});

//* MySetting *//
export const MySetting = Loadable({
  loader: () => import('./my/Setting'),
  loading: Loading,
});

//* MyDropOut *//
export const MyDropOut = Loadable({
  loader: () => import('./my/DropOut'),
  loading: Loading,
});

//구매내역
export const MyPurchaseHistory = Loadable({
  loader: () => import('./my/purchase/History'),
  loading: Loading,
});

//쿠폰리스트
export const MyCouponList = Loadable({
  loader: () => import('./my/coupon/List'),
  loading: Loading,
});

//* Login *//
// export const Login = Loadable({
//   loader: () => import('./member/Login'),
//   loading: Loading,
// });

//* Join *//
// export const Join = Loadable({
//   loader: () => import('./member/Join'),
//   loading: Loading,
// });

//* Find *//
// export const Find = Loadable({
//   loader: () => import('./member/Find'),
//   loading: Loading,
// });

//* Customer 고객센터 *//
export const Customer = Loadable({
  loader: () => import('./member/CustomerHooks'),
  // class component 에서 hooks로 교체
  // loader: () => import('./member/Customer'),
  loading: Loading,
});
//* Experience 7일 무료 체험 *//
export const Experience = Loadable({
  loader: () => import('./member/Experience'),
  loading: Loading,
});
//* Setting 사용자 설정 *//
export const Setting = Loadable({
  loader: () => import('./member/Setting'),
  loading: Loading,
});
//* Membership *//
export const Membership = Loadable({
  loader: () => import('./member/Membership'),
  loading: Loading,
});

//* Manual * //
export const Manual = Loadable({
  loader: () => import('./member/Manual'),
  loading: Loading,
});

//* 무료멤버 강의제한 *//
export const MemberBlock = Loadable({
  loader: () => import('./member/MemberBlock'),
  loading: Loading,
});

//* Home *//
export const Home = Loadable({
  loader: () => import('./Home'),
  loading: Loading,
});

//* Intro *//
export const Intro = Loadable({
  loader: () => import('./Intro'),
  loading: Loading,
});

//* purchase - pay - product *//
export const PruchasePayProducts = Loadable({
  loader: () => import('./introduce/purchase/pay/Products'),
  loading: Loading,
});
export const PruchasePayProductDetail = Loadable({
  loader: () => import('./introduce/purchase/pay/Product'),
  loading: Loading,
});

export const PruchaseRepayProductDetail = Loadable({
  loader: () => import('./introduce/purchase/repay/RepayProduct'),
  loading: Loading,
});
export const PruchasePayComplete = Loadable({
  loader: () => import('./introduce/purchase/pay/Product'),
  loading: Loading,
});
export const PruchasePayStandby = Loadable({
  loader: () => import('./introduce/purchase/pay/Product'),
  loading: Loading,
});
export const PruchaseHistory = Loadable({
  loader: () => import('./introduce/purchase/History'),
  loading: Loading,
});

export const PruchaseFailure = Loadable({
  loader: () => import('./introduce/purchase/result/FailurePage'),
  loading: Loading,
});
export const PruchaseSuccess = Loadable({
  loader: () => import('./introduce/purchase/result/SuccessPage'),
  loading: Loading,
});

// 내 학습
export const MyStudyStatus = Loadable({
  loader: () => import('./mystudy/Status'),
  loading: Loading,
});
export const MyStudyLockerScript = Loadable({
  loader: () => import('./mystudy/locker/Script'),
  loading: Loading,
});
export const MyStudyLockerDictionary = Loadable({
  loader: () => import('./mystudy/locker/Dictionary'),
  loading: Loading,
});
export const MyStudyLockerDictionaryMemorization = Loadable({
  loader: () => import('./mystudy/locker/DictionaryMemorization'),
  loading: Loading,
});

// 100곡 리스트
export const LectureList = Loadable({
  loader: () => import('./playlist/LectureList'),
  loading: Loading,
});

//* Study *//
// Study / 상세
export const StudyDetail = Loadable({
  loader: () => import('./study/Detail'),
  loading: Loading,
});

// Study / 강의
export const StudyLecture = Loadable({
  loader: () => import('./study/Lecture'),
  loading: Loading,
});
// Study / 리스트
// export const StudyList = Loadable({
//   loader: () => import('./study/List'),
//   loading: Loading,
// });
// Study / 듣기
export const StudyListen = Loadable({
  loader: () => import('./study/Listen'),
  loading: Loading,
});
// Study / 실전 - 학습 진행상황
export const StudyPractice = Loadable({
  loader: () => import('./study/Practice'),
  loading: Loading,
});
// Study / 실전 - 학습
export const StudyPracticeStudy = Loadable({
  loader: () => import('./study/PracticeStudy'),
  loading: Loading,
});
// Study / 실전 - 학습
export const StudyPracticeResult = Loadable({
  loader: () => import('./study/PracticeResult'),
  loading: Loading,
});
// Study / 팝송
export const StudySong = Loadable({
  loader: () => import('./study/Song'),
  loading: Loading,
});
// Study / 말하기
export const StudySpeak = Loadable({
  loader: () => import('./study/Speak'),
  loading: Loading,
});

//* Player *//
export const ByType = Loadable({
  loader: () => import('./playlist/ByType'),
  loading: Loading,
});
//1000곡 저작권 리스트
export const SongsCopyRight = Loadable({
  loader: () => import('./playlist/SongsCopyRight'),
  loading: Loading,
});
// Player / 장르
export const PlayerGenre = Loadable({
  loader: () => import('./player/Genre'),
  loading: Loading,
});
// Player / 무드
export const PlayerMood = Loadable({
  loader: () => import('./player/Mood'),
  loading: Loading,
});
// Player / 곡검색
export const PlayerSearch = Loadable({
  loader: () => import('./player/Search'),
  loading: Loading,
});
// Player / 곡검색
export const PlayerPlay = Loadable({
  loader: () => import('./player/Play'),
  loading: Loading,
});

//* 404 *//
export const NotFound = Loadable({
  loader: () => import('./NotFound'),
  loading: Loading,
});

export const MyChallenge = Loadable({
  loader: () => import('./my/challenge/Challenge'),
  loading: Loading,
});

export const MyMission = Loadable({
  loader: () => import('./my/challenge/Mission'),
  loading: Loading,
});

export const MyProgress = Loadable({
  loader: () => import('./my/challenge/Progress'),
  loading: Loading,
});

export const MyNeedPaper = Loadable({
  loader: () => import('./my/challenge/Paper'),
  loading: Loading,
});

//* Test Page *//
// export const TestPage = Loadable({
//   loader: () => import('./TestPage'),
//   loading: Loading,
// });

// // Learning
// export const Learning = Loadable({
//   loader: () => import('./Learning'),
//   loading: Loading,
// });

export const PrivacyPolicyDevice = Loadable({
  loader: () => import('./PrivacyPolicyDevice'),
  loading: Loading,
});
export const PrivacyPolicy = Loadable({
  loader: () => import('./PrivacyPolicy'),
  loading: Loading,
});

/** Selling */
// export const SellingWeb = Loadable({
//   loader: () => import('./selling/Web'),
//   loading: Loading,
// });

// Facebook 전용 - preorder
export const FacebookSellingWebB = Loadable({
  loader: () => import('./selling/facebook/WebB'),
  loading: Loading,
});

// Facebook 전용 - nsda_pops
export const FacebookSellingWebNSDAPops = Loadable({
  loader: () => import('./selling/facebook/WebNSDAPops'),
  loading: Loading,
});

//셀링B
export const SellingWebB = Loadable({
  loader: () => import('./selling/WebB'),
  loading: Loading,
});

//셀링SP
export const SellingWebSP = Loadable({
  loader: () => import('./selling/WebSP'),
  loading: Loading,
});

export const SellingWebY = Loadable({
  loader: () => import('./selling/WebY'),
  loading: Loading,
});

export const SellingWebBenefit = Loadable({
  loader: () => import('./selling/WebBenefit'),
  loading: Loading,
});
export const SellingWebLecture = Loadable({
  loader: () => import('./selling/WebLecture'),
  loading: Loading,
});
export const SellingWebFunction = Loadable({
  loader: () => import('./selling/WebFunction'),
  loading: Loading,
});
export const SellingWebStudy = Loadable({
  loader: () => import('./selling/WebStudy'),
  loading: Loading,
});
export const SellingWebQuiz = Loadable({
  loader: () => import('./selling/WebQuiz'),
  loading: Loading,
});

export const SellingWebQuizB = Loadable({
  loader: () => import('./selling/WebQuizB'),
  loading: Loading,
});

export const SellingWebNSDAPops = Loadable({
  loader: () => import('./selling/WebNSDAPops'),
  loading: Loading,
});

export const SellingWebNSDAPops2 = Loadable({
  loader: () => import('./selling/WebNSDAPops2'),
  loading: Loading,
});

export const SellingWebNSDAQuiz = Loadable({
  loader: () => import('./selling/WebNSDAQuiz'),
  loading: Loading,
});

export const SellingWebNSDAAlarm = Loadable({
  loader: () => import('./selling/WebNSDAAlarm'),
  loading: Loading,
});

export const SellingWebNSDADoctor = Loadable({
  loader: () => import('./selling/WebNSDADoctor'),
  loading: Loading,
});

///// POPUP Module
export const SellingWebPopupNSDAQuiz2 = Loadable({
  loader: () => import('./selling/popup/WebNSDAQuiz2'),
  loading: Loading,
});

export const SellingWebPopupNSDAPops3 = Loadable({
  loader: () => import('./selling/popup/WebNSDAPops3'),
  loading: Loading,
});

export const SellingWebPopupNSDADoctor = Loadable({
  loader: () => import('./selling/popup/WebNSDADoctor'),
  loading: Loading,
});

export const SellingWebPopupNSDAAlarm = Loadable({
  loader: () => import('./selling/popup/WebNSDAAlarm'),
  loading: Loading,
});

export const SellingWebPopup10m = Loadable({
  loader: () => import('./selling/popup/Web10m'),
  loading: Loading,
});

//굿모닝 팝스
export const SellingWebP = Loadable({
  loader: () => import('./selling/WebP'),
  loading: Loading,
});

export const IsDrMuzy = Loadable({
  loader: () => import('../../pages/selling/Main'),
  loading: Loading,
});

// export const FreeExperience = Loadable({
//   loader: () => import('../../pages/freeexperience/FreeMain'),
//   loading: Loading,
// });
